<template>
  <div class="uk-margin">
    <label class="uk-form-label uk-display-block" v-html="label">
    </label>

    <div class="kmc-field-help-text" v-if="helpText">
        <p v-html="helpText"></p>
    </div>

    <div class="uk-form-controls uk-flex uk-flex-column">
      <label v-for="option in options" class="kmc-radio uk-flex-1">
        <input
            type="radio"
            :name="name"
            :value="option.value"
            v-model="inputValue"
        />
        <span class="uk-width-1-1 uk-text-center">
            {{ option.label }}
        </span>
      </label>
    </div>
    <div class="kmc-field-error-text">
      {{ errorMessage }}
    </div>
  </div>
</template>

<script>
import {ref} from 'vue';
import {useField} from "vee-validate";

export default {
  name: "KmcInputRadio",
  props: {
    helpText: {
      type: String,
    },
    value: {
      type: String,
      default: "",
    },
    name: {
      type: String,
    },
    label: {
      type: String,
    },
    options: {
      type: Array,
    }
  },
  setup: function (props, context) {

    const input = ref(null)

    const {
      value: inputValue,
      errorMessage,
      meta,
    } = useField(props.name, undefined, {
      initialValue: props.value,
    });

    return {
      input,
      errorMessage,
      inputValue,
      meta,
    };
  }
}

</script>

